define('modules/page_listing/models/querystring',['require','exports','module','backbone'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone");

  module.exports = Backbone.Model.extend({
    initialize: function(){
      // this.on("change", this.navigate);
    },
    useParamsFrom: function(model) {
      //this.update(model, {silent: true});
      this.listenTo(model, "change", this.update);
    },
    update: function(model, options) {
      // clear everytime a model is updated
      // because we don't wanna use multiple
      // forms, remove if we want
      // this.clear({silent: true});
      this.set(model.toJSON(), options);
    },
    parseString: function(qs) {
      var cleanObj = module.exports.parse(qs);
      this.set(cleanObj, {silent: true});
    },
    toString: function() {
      var pairs = _.pairs(this.toJSON());
      return module.exports.serialize(pairs);
    },
    navigate: function() {
      var url = "pages?" + this.toString(),
          fragment = Backbone.history.fragment;
      if (url === fragment) Backbone.history.fragment = '';
      Backbone.history.navigate(url, {replace: true});
    },
    hasSet: function(attr) {
      return this.has(attr) && this.get(attr);
    }
  }, {
    parse: function(qs) {
      if (!qs) return {};
      qs = decodeURIComponent(qs || "");
      var pairs = qs.split("&"),
          qsObj = _.reduce(pairs, function(obj, pair){
            var attr = _.object([pair.split("=")]);
            return _.extend(obj, attr);
          }, {});
      return _.omit(qsObj, function(value){ return !value; });
    },
    serialize: function(json) {
      return _.map(json, function(attr){
        attr[1] = encodeURIComponent(attr[1]);
        return attr.join("=");
      }).join("&");
    }
  });

});

